import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import ServicesEditorial from "@/components/home/ServicesEditorial";
import ProcessSection from "@/components/home/ProcessSection";
import TechEcosystem from "@/components/home/TechEcosystem";
import FinalCTA from "@/components/home/FinalCTA";
import { PrimaryCTA } from "@/components/CTAButton";

export default function Services() {
  return (
    <>
      <SEO
        title="Services | All Data Tech"
        description="Data engineering, AI & machine learning, business intelligence, analytics, predictive analytics, cloud data, automation and custom data solutions."
        path="/services"
      />
      <PageHero
        eyebrow="Services"
        title={<>Services that turn data into <span className="text-gradient">business impact.</span></>}
        sub="Consistent, outcome-focused delivery across the full data and AI lifecycle — what it is, what it solves, and how we deliver."
      >
        <PrimaryCTA to="/consultation" testId="services-hero-cta">Book a Consultation</PrimaryCTA>
      </PageHero>
      <ServicesEditorial heading={false} />
      <ProcessSection />
      <TechEcosystem />
      <FinalCTA />
    </>
  );
}
